import { useTranslation } from "react-i18next";
import { CacheRefreshButton } from "@/shared/components/CacheRefreshButton";
import { useRefreshFeatureFlagsCache } from "./use-refresh-feature-flags-cache";

export function RefreshFeatureFlagsButton() {
  const { t } = useTranslation();
  const refresh = useRefreshFeatureFlagsCache();
  return (
    <CacheRefreshButton
      mutation={refresh}
      labels={{
        idle: t("featureFlags.refresh.button"),
        pending: t("featureFlags.refresh.pending"),
        success: t("featureFlags.refresh.success"),
      }}
      errorKeys={{
        forbiddenKey: "featureFlags.errors.forbidden",
        serverPrefixKey: "featureFlags.errors.serverPrefix",
        genericKey: "featureFlags.refresh.error",
      }}
      testIdPrefix="refresh-feature-flags-cache"
    />
  );
}
